export const initSagas = (sagas, sagaMiddleware) => {
    Object.values(sagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
};
//# sourceMappingURL=sagas.js.map